import { render, staticRenderFns } from "./finishingsTable.vue?vue&type=template&id=1b75e9b4"
import script from "./finishingsTable.vue?vue&type=script&lang=js"
export * from "./finishingsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports